"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventsModel = /** @class */ (function () {
    function EventsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/events",
            UPDATE: APPURL + "/api/v1/events",
            CREATE: APPURL + "/api/v1/events",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    EventsModel.prototype.extract = function (result) {
        return result.data;
    };
    EventsModel.prototype.cacheResults = function (result) {
        var data = this.extract(result);
        if (data && typeof data === "object" && "events" in data) {
            this.data = data.events;
        }
        else if (Array.isArray(data)) {
            this.data = data;
        }
        return data;
    };
    EventsModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    EventsModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    EventsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    EventsModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    EventsModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    EventsModel.prototype.search = function (params) {
        if (params.paginate) {
            return this.$http
                .post(this.URLS.FETCH + "/search", params)
                .then(this.cacheResults);
        }
        return this.$http
            .post(this.URLS.FETCH + "/search", params)
            .then(this.cacheResults);
    };
    EventsModel.prototype.batchCreate = function (data) {
        return this.$http
            .post(this.URLS.CREATE + "/batch", data)
            .then(this.cacheResults);
    };
    return EventsModel;
}());
EventsModel.$inject = ["$http", "APPURL"];
exports.default = EventsModel;
